const STATUS_PRIORITY = {
  pending: 0,
  accepted: 1,
  declined: 2,
  cancelled: 3,
  completed: 4,
};

function getCreatedTime(apt) {
  const raw = apt?.createdAt || apt?.created || apt?.updatedAt;
  const t = raw ? new Date(raw).getTime() : 0;
  return Number.isNaN(t) ? 0 : t;
}

function getAppointmentDate(apt) {
  const t = new Date(apt?.selectedDate || 0).getTime();
  return Number.isNaN(t) ? 0 : t;
}

export function sortShopOwnerAppointments(list, sortBy = 'date', sortOrder = 'desc') {
  const items = [...(list || [])];

  return items.sort((a, b) => {
    const statusDiff = (STATUS_PRIORITY[a?.status] ?? 99) - (STATUS_PRIORITY[b?.status] ?? 99);
    if (statusDiff !== 0) return statusDiff;

    let aVal;
    let bVal;
    switch (sortBy) {
      case 'price':
        aVal = parseFloat(a.totalPrice) || 0;
        bVal = parseFloat(b.totalPrice) || 0;
        break;
      case 'name':
        aVal = a.user?.name || '';
        bVal = b.user?.name || '';
        break;
      case 'date':
      default:
        aVal = getAppointmentDate(a) || getCreatedTime(a);
        bVal = getAppointmentDate(b) || getCreatedTime(b);
        break;
    }

    if (sortOrder === 'asc') return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
    return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
  });
}
